import { CoreIcon } from '../core-icon';
import navigateSVG from '../../assets/icons/navigate.svg';
import type { IconProps } from '../core-icon';

export const NavigateIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={navigateSVG} {...props} />;
};
